import { InitPdfium } from "@pdfking/renderer-wasm-pdfium"
import { CreateSingleton, StringToUInt8 } from "@pdfking/tfunc"

export const InitializePdfium = CreateSingleton(async () => {
  const pdfium = await InitPdfium()

  // --- ONE LIST WITH JS NAME + C NAME + RETURN + ARGS ---
  const SPECS = [
    // Init now lives here
    ["Init", "PDFium_Init", null, []],

    [
      "LoadMemDocument",
      "FPDF_LoadMemDocument",
      "number",
      ["number", "number", "number"],
    ],
    ["CloseDocument", "FPDF_CloseDocument", null, ["number"]],
    ["GetPageCount", "FPDF_GetPageCount", "number", ["number"]],
    ["GetLastError", "FPDF_GetLastError", "number", []],
    ["DestroyLibrary", "FPDF_DestroyLibrary", null, []],

    ["LoadPage", "FPDF_LoadPage", "number", ["number", "number"]],
    ["ClosePage", "FPDF_ClosePage", null, ["number"]],
    ["GetPageWidthF", "FPDF_GetPageWidthF", "number", ["number"]],
    ["GetPageHeightF", "FPDF_GetPageHeightF", "number", ["number"]],
    [
      "GetPageSizeByIndexF",
      "FPDF_GetPageSizeByIndexF",
      "number",
      ["number", "number", "number", "number"],
    ],
    [
      "Page_GetTrimBox",
      "FPDFPage_GetTrimBox",
      "number",
      ["number", "number", "number", "number", "number"],
    ],

    [
      "Bitmap_Create",
      "FPDFBitmap_Create",
      "number",
      ["number", "number", "number"],
    ],
    ["Bitmap_Destroy", "FPDFBitmap_Destroy", null, ["number"]],
    [
      "Bitmap_FillRect",
      "FPDFBitmap_FillRect",
      null,
      ["number", "number", "number", "number", "number", "number"],
    ],
    ["Bitmap_GetBuffer", "FPDFBitmap_GetBuffer", "number", ["number"]],

    [
      "RenderPageBitmap",
      "FPDF_RenderPageBitmap",
      null,
      [
        "number",
        "number",
        "number",
        "number",
        "number",
        "number",
        "number",
        "number",
      ],
    ],

    ["CreateNewDocument", "FPDF_CreateNewDocument", "number", []],
    [
      "ImportPages",
      "FPDF_ImportPages",
      "number",
      ["number", "number", "number", "number"],
    ],
    ["SaveAsCopy", "FPDF_SaveAsCopy", "number", ["number", "number", "number"]],

    ["AvailCreate", "FPDFAvail_Create", "number", ["number", "number"]],
    ["AvailDestroy", "FPDFAvail_Destroy", null, ["number"]],
    ["AvailIsDocAvail", "FPDFAvail_IsDocAvail", "number", ["number", "number"]],
    [
      "AvailGetDocument",
      "FPDFAvail_GetDocument",
      "number",
      ["number", "number"],
    ],
    [
      "AvailIsPageAvail",
      "FPDFAvail_IsPageAvail",
      "number",
      ["number", "number", "number"],
    ],
  ] as const

  // --- AUTO-GENERATE EVERYTHING ---
  const api = Object.fromEntries(
    SPECS.map(([jsName, cName, ret, args]) => [
      jsName,
      pdfium.cwrap(cName, ret ?? "", args),
    ])
  )

  // Helper (unchanged)
  pdfium.stringToUTF8Helper = (str: string, ptr: number, max: number) => {
    const bytes = StringToUInt8(str)
    const len = Math.min(bytes.length, max - 1)
    pdfium.HEAPU8.set(bytes.subarray(0, len), ptr)
    pdfium.HEAPU8[ptr + len] = 0
  }

  // --- MANUALLY INIT AFTER construction ---
  api.Init()

  return { pdfium, ...api }
})
